module.exports = __webpack_public_path__ + "img/csharp.de161127.png";